import React, { Component } from 'react'
import { Button } from 'hljd'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import Store from './store'
@observer
class Shangshangqian extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }
  async componentDidMount() {
    this.store.checkSigned()
  }
  render() {
    const {
      ShangshangqianInfo,
      buttonText,
      showClose,
      isVisiable,
      checkSigned,
      sign,
      edit
    } = this.store
    const { realname, certify, address, contact } = ShangshangqianInfo
    return isVisiable ? (
      <div className={styles.mask}>
        <div className={styles.content}>
          <div className={styles.title}>个体商家说明</div>
          <div className={styles.text}>
            尊敬的婚礼纪商户：依照《中华人民共和国电子商务法》、《网络交易监督管理办法》等法律规定，个人商户在婚礼纪从事经营活动，需要登记以下营业信息，并签字确认。
          </div>
          <div className={styles.info}>
            <p>真实姓名：{realname}</p>
            <p>身份证号：{certify}</p>
            <p>实际经营地址：{address}</p>
            <p>联系方式：{contact}</p>
          </div>
          <div className={styles.footer}>
            {showClose ? (
              <Button
                type="primary"
                ghost
                onClick={() => checkSigned('click')}
                asyncClickAutoLoading
              >
                已签字，关闭窗口
              </Button>
            ) : (
              <Button type="primary" onClick={sign} asyncClickAutoLoading>
                {buttonText}
              </Button>
            )}
            <div className={styles.right} onClick={edit}>
              信息有误？点击修改 <span />
            </div>
          </div>
        </div>
      </div>
    ) : null
  }
}

export default Shangshangqian
